import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';

import styled from '@emotion/styled';

export const StarWrapper = styled(Box)<{ isSelected?: boolean; isHovered?: boolean }>`
  cursor: pointer;
  color: ${({ isSelected }) => (isSelected ? theme.colors.yellow800 : theme.colors.black)};
  transition: 0.1s ease-in-out;
  svg {
    fill: ${({ isSelected }) => (isSelected ? theme.colors.yellow800 : 'none')};
  }
  &:hover {
    color: ${({ isSelected }) => (isSelected ? theme.colors.yellow800 : theme.colors.yellow200)};
    svg {
      fill: ${({ isSelected }) => (isSelected ? theme.colors.yellow800 : theme.colors.yellow200)};
    }
  }
  &:has(~ &:hover) {
    color: ${({ isSelected }) => (isSelected ? theme.colors.yellow800 : theme.colors.yellow200)};
    svg {
      fill: ${({ isSelected }) => (isSelected ? theme.colors.yellow800 : theme.colors.yellow200)};
    }
  }
`;
